/**
 * Normalise transcript display from stored recording shape (segments or "Name: text" blocks).
 */
export function getTranscriptSegments(recording) {
    const stored = recording?.insights?.transcriptSegments;
    if (Array.isArray(stored) && stored.length > 0) {
        return stored
            .filter((s) => s && s.text)
            .map((s) => ({
                speaker: String(s.speaker || 'Speaker 1').trim() || 'Speaker 1',
                text: String(s.text).trim()
            }));
    }

    const raw = recording?.transcript || recording?.content || '';
    if (!raw || typeof raw !== 'string') return [];

    const blocks = raw.split(/\n\n+/).map((b) => b.trim()).filter(Boolean);
    const segments = [];

    for (const block of blocks) {
        const match = block.match(/^([^:\n]{1,80}):\s*([\s\S]+)$/);
        if (match) {
            segments.push({ speaker: match[1].trim(), text: match[2].trim() });
        } else if (segments.length === 0) {
            segments.push({ speaker: 'Speaker 1', text: block });
        } else {
            segments[segments.length - 1].text += `\n\n${block}`;
        }
    }

    return segments;
}

export function getMeetingNotes(recording) {
    const notes = recording?.insights?.meetingNotes;
    if (notes && (notes.summary || notes.nextSteps?.length)) {
        return {
            summary: notes.summary || recording?.insights?.summary || '',
            nextSteps: Array.isArray(notes.nextSteps) ? notes.nextSteps : []
        };
    }
    if (recording?.insights?.summary) {
        return {
            summary: recording.insights.summary,
            nextSteps: Array.isArray(recording.insights.followUps) ? recording.insights.followUps : []
        };
    }
    return null;
}
